import { LabelVariant } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';

import { LoanExceptionCategory, LoanExceptionStatus } from 'store/loanExceptions/types';

export const VIEW_CLAIM = 'exceptionTracking.view';
export const APPROVE_CLAIM = 'exceptionTracking.approve';

export const noValidateInputProps = { 'data-novalidate': true };

export const LoanExceptionCategoryLabels = {
  [LoanExceptionCategory.PRICING]: 'Pricing',
  [LoanExceptionCategory.UNDERWRITING_GUIDELINE]: 'Underwriting guideline',
  [LoanExceptionCategory.FEE_ADJUSTMENT_TO_AVOID_HPML]: 'Fee adjustment to avoid HPML',
  [LoanExceptionCategory.CREDIT_COMMITTEE]: 'Credit committee',
};

export const loanExceptionCategoryOptions = Object.entries(LoanExceptionCategoryLabels).map(
  ([value, label]) => ({ value, label }),
);

export const LoanExceptionStatusLabels = {
  [LoanExceptionStatus.SUBMITTED]: 'Submitted',
  [LoanExceptionStatus.UNDER_REVIEW]: 'Under review',
  [LoanExceptionStatus.APPROVED]: 'Approved',
  [LoanExceptionStatus.DENIED]: 'Denied',
  [LoanExceptionStatus.WITHDRAWN]: 'Withdrawn',
};

export const LoanExceptionStatusLabelVariants = {
  [LoanExceptionStatus.SUBMITTED]: LabelVariant.BLUE,
  [LoanExceptionStatus.UNDER_REVIEW]: LabelVariant.ORANGE,
  [LoanExceptionStatus.APPROVED]: LabelVariant.GREEN,
  [LoanExceptionStatus.DENIED]: LabelVariant.RED,
  [LoanExceptionStatus.WITHDRAWN]: LabelVariant.GRAY,
};

export const ExceptionsTableColumnId = {
  CATEGORY: 'category',
  SUB_CATEGORY_NAME: 'subCategoryName',
  SUBJECT: 'subject',
  STATUS: 'status',
  REQUESTED_BY_USER_NAME: 'requestedByUserName',
  REQUESTED_DATE: 'requestedDate',
  DECIDED_BY_USER_NAME: 'decidedByUserName',
  DECISIONED_DATE: 'decisionedDate',
  ACTION: 'action',
};
